<template>
  <div class="listing-main">
    <div class="top-bar">
      <div class="title">{{ title }} Selected {{ items.filter((i) => { return i['selected'] }).length }} / {{ items.length }}</div>
      <button v-if="!isDisabled" @click="editting ^= true">{{ editting ? 'Done' : 'Edit' }}</button>
    </div>

    <div class="listing" @contextmenu="contextMenu">
      <div class="list-items" v-for="(i, ind) in items" :key="ind">
        <div v-if="editting">
          <CheckBoxV2 :title="i.item" :isChecked.sync="i.selected"/>
          <div style="margin: 0px 5px">-</div>
          <input type="text" placeholder="Remarks" v-model="i.remarks" @keydown="keyDown" maxlength="100" >
        </div>
        <div v-else-if="i.selected">
          <span>{{ i.item }}</span>
          <span v-if="i.remarks" style="margin-left: 5px">- {{ i.remarks }}</span>
        </div>
        <!-- <div v-else>
          <span :style="{ textDecoration: i['selected'] ? 'none' : 'line-through' }">{{ i.item }}</span>
          <span :style="{ textDecoration: i['selected'] ? 'none' : 'line-through', marginLeft: '5px' }">- {{ i['remarks'] ? i['remarks'] : 'No remarks' }}</span>
        </div> -->
      </div>
    </div>

    <div v-if="showMenu" class="context-menu">
      Items
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import CheckBox from '@/components/CheckBox.vue';

export default {
  components: {
    CheckBox
  },
  data() {
    return {
      editting: false,
      showMenu: false,
    }
  },
  props: {
    // Public properties
    title: { type: String, default: 'Title' }, // The title of the ItemListing
    items: { type: Array, default: function() { return [] } }, // The array of items object in the ItemList. Eg: { selected: true, item: 'Your item name', remarks: 'Your remarks' }
    isDisabled: { type: Boolean, default: false },
  },
  watch:{
    isDisabled(n) {
      if (n) { // if isDisabled is true, set the listing into view mode
        this.editting = false; 
      }
    },
  },
  methods: {
    keyDown: function(e) {
      if (e.ctrlKey && e.key == 'Enter') {
        this.editting = false;
      }
    },
    contextMenu: function(e) {
      // console.log(e);
      // e.preventDefault();
      // this.showMenu = true;
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/css/all.scss';
$top-bar-height: 25px;

.listing-main {
  font-size: 12px;
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  margin: 3px 0;
  position: relative;
}

.top-bar {
  display: flex;
  align-items: center;
  height: $top-bar-height;

  .title {
    flex-grow: 1;
  }

  button {
    padding: 1px 7px;
  }
}

.listing {
  border: 1px solid rgb(160,160,160);
  width: 100%;
  height: 100%;
  margin-top: 1px;
  overflow-y: scroll;

  .list-items >* {
    display: flex;
    padding: 6px;
    border-bottom: 1px solid rgb(160,160,160);

    input {
      padding: 0;
      margin: 0;
      border-width: 0 0 1px 0;
      border-color: gray;
      border-style: solid;
      flex-grow: 1;
    }

    input:focus {
      outline: none;
    }
  }
}

.context-menu {
  position: absolute;
  background-color: white;
  border: 1px solid black;
}
</style>